import React from 'react';
import { CheckIcon, CreditCardIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { Countdown } from './Countdown';
import { packageIncludes } from '../data/salesCopy';
export function OfferSummary() {
  return <section id="offer" className="w-full border-b border-line bg-paper" data-id="element-143" data-mp="1eytwp60jkays">
      <div className="mx-auto max-w-5xl px-4 py-12 sm:px-5 sm:py-16 lg:py-20" data-id="element-144" data-mp="1a2mnn4cumjcm">
        <div className="flex flex-col gap-6 sm:flex-row sm:items-end sm:justify-between" data-id="element-145" data-mp="mdk8c35ot2la">
          <div data-id="element-146" data-mp="he7e2xchkt8o">
            <p className="text-[11px] font-semibold uppercase tracking-[0.2em] text-rust sm:text-xs" data-id="element-147" data-mp="heqrq1v3svgw">
              Limited-time offer
            </p>
            <h2 className="mt-3 font-display text-2xl font-semibold leading-tight tracking-tight text-ink sm:mt-4 sm:text-4xl" data-id="element-148" data-mp="rblp2hfn4ptl">
              The 60% off promo expires in
            </h2>
            <p className="mt-3 max-w-md text-sm leading-relaxed text-ink-muted sm:mt-4" data-id="element-149" data-mp="3joj36yvgs0e">
              This price ends tonight. After that, the bundle returns to its regular price.
            </p>
          </div>
          <Countdown data-id="element-150" data-mp="1gk84s4d67g8x" />
        </div>

        <div className="mt-8 sm:mt-10" data-id="element-151" data-mp="1gjewgyykcioo">
          <div className="flex items-baseline justify-between gap-3" data-id="element-152" data-mp="1gi3qqtlk50ux">
            <span className="text-[10px] font-semibold uppercase tracking-[0.14em] text-ink-muted sm:text-xs" data-id="element-153" data-mp="1lbq6wvqxjmvh">
              Limited availability — today only
            </span>
            <span className="text-[10px] font-semibold uppercase tracking-[0.14em] text-rust sm:text-xs" data-id="element-154" data-mp="tl26xn0zsnje">
              68% claimed
            </span>
          </div>
          <div className="mt-3 h-2 w-full overflow-hidden rounded-full bg-line" role="progressbar" aria-valuenow={68} aria-valuemin={0} aria-valuemax={100} aria-label="Launch spots claimed" data-id="element-155" data-mp="12kp05ljkin1d">
            <div className="h-full w-[68%] rounded-full bg-rust" data-id="element-156" data-mp="2e1ydrrg0mkur" />
          </div>
        </div>

        <div className="mt-8 overflow-hidden rounded-2xl border border-line bg-surface sm:mt-10" data-id="element-157" data-mp="2j11mblv7f97h">
          <div className="border-b border-line px-5 py-5 sm:px-10 sm:py-6" data-id="element-158" data-mp="1tcw6sod2fstp">
            <p className="text-[10px] font-semibold uppercase tracking-[0.14em] text-ink-muted sm:text-xs" data-id="element-159" data-mp="1ob6smzujqz1e">
              TeachersKit™ — the complete “Teacher Survival” bundle
            </p>
            <h3 className="mt-2 font-display text-xl font-semibold text-ink sm:text-3xl" data-id="element-160" data-mp="1yb7g8xzg81be">
              6 Volumes + 5 Free Bonuses
            </h3>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-[1fr_0.9fr]" data-id="element-161" data-mp="15lgwa8b4y57d">
            <div className="border-b border-line px-5 py-6 sm:px-10 sm:py-8 lg:border-b-0 lg:border-r" data-id="element-162" data-mp="15jdz94bkfbt5">
              <p className="text-[10px] font-semibold uppercase tracking-[0.14em] text-ink-muted sm:text-xs" data-id="element-163" data-mp="1kby203uszha2">
                What’s included
              </p>
              <ul className="mt-4 space-y-2.5 sm:mt-5 sm:space-y-3" data-id="element-164" data-mp="rsix0avknsyj">
                {packageIncludes.map(item => <li key={item} className="flex items-start gap-3 text-[15px] text-ink-soft" data-id="element-165" data-mp="muh6x5zqatdk">
                    <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-rust" aria-hidden="true" data-id="element-166" data-mp="2ygrpfznqlww7" />
                    {item}
                  </li>)}
              </ul>
              <p className="mt-6 border-t border-line pt-4 text-xs font-semibold uppercase tracking-[0.1em] text-ink sm:mt-7 sm:pt-5 sm:text-sm" data-id="element-167" data-mp="2olhm98llrjgu">
                Total real value: $745
              </p>
            </div>

            <div className="bg-paper px-5 py-7 text-center sm:px-10 sm:py-8" data-id="element-168" data-mp="3h6hh4dw7e2jw">
              <p className="flex items-baseline justify-center gap-3" data-id="element-169" data-mp="3m757qygishdl">
                <span className="font-display text-5xl font-semibold tracking-tight text-ink sm:text-6xl" data-id="element-170" data-mp="388nll569jcxs">
                  $19
                </span>
                <span className="font-display text-xl font-medium text-ink-muted line-through sm:text-2xl" data-id="element-171" data-mp="3cbk8h82u5v7j">
                  $745
                </span>
              </p>
              <p className="mt-3 text-xs font-semibold uppercase tracking-[0.1em] text-rust sm:text-sm" data-id="element-172" data-mp="20vvo8ogyvaaf">
                You save $726 — 97% discount
              </p>
              <p className="mt-1 text-[10px] font-medium uppercase tracking-[0.14em] text-ink-muted sm:text-xs" data-id="element-173" data-mp="2ca8j3ckc349z">
                One-time payment · Lifetime access
              </p>

              <div className="mt-6 sm:mt-7" data-id="element-174" data-mp="22cuafz4njjs8">
                <CtaButton size="large" align="center" fullWidth placement="offer_card" label="Give me the TeachersKit bundle now" mobileLabel="Get the bundle — $19" note="Covered by our 30-day money-back guarantee." data-id="element-175" data-mp="22e5f015x8vke" />
              </div>

              <ul className="mt-6 flex flex-col items-center gap-2 text-xs font-medium text-ink-muted" data-id="element-176" data-mp="2lzi8gknsm8ue">
                <li className="flex items-center gap-1.5" data-id="element-177" data-mp="1eo1ew3rxzdy5">
                  <ShieldCheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-178" data-mp="1aleirqo8n6v5" />
                  Secure payment
                </li>
                <li className="flex items-center gap-1.5" data-id="element-179" data-mp="3m9rokwm0lpet">
                  <ZapIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-180" data-mp="3qablbz2oer0f" />
                  PDFs sent to your email
                </li>
                <li className="flex items-center gap-1.5" data-id="element-181" data-mp="3v96ffx63g1zu">
                  <CreditCardIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-182" data-mp="3uqtxsd4kf9l" />
                  Card · Google Pay · Apple Pay
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>;
}